import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function CartFab() {
  const { totals, setOpen } = useCart();
  if (totals.count === 0) return null;
  return (
    <button
      onClick={() => setOpen(true)}
      data-testid="cart-fab"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-ember hover:bg-emberDeep text-white pl-4 pr-5 py-3 rounded-full font-medium shadow-[0_20px_50px_-10px_rgba(200,16,46,0.6)] border border-white/10 transition-colors"
    >
      <span className="relative">
        <ShoppingBag size={18} />
        <span className="absolute -top-2 -right-2 bg-gold text-ink text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 grid place-items-center">
          {totals.count}
        </span>
      </span>
      <span className="text-sm">€{totals.price.toFixed(totals.price % 1 ? 2 : 0)}</span>
    </button>
  );
}
